module.exports = __webpack_public_path__ + "img/sergeant-nan-bg.f9adfba5.png";